import React from 'react'
import s from './styles/HorizontalScroller.module.scss'
import { useHorizontalScroll } from './hooks/useHorizontalScroll'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrowLeft.svg'

export default function HorizontalScroller({
	children,
	className = '',
	innerClassName = '',

	showArrows = true,
	axis = 'x',

	hideScrollbar = true,

	dragToScroll = true,
	wheelMode = 'native',

	stepRatio = 0.6,

	dragThresholdPx = 8,
	ignoreDragFrom,
	arrowMode = 'page',
	snapSelector,
	snapAlign = 'start',
	arrowOverlapRatio,
}) {
	const { ref, bind, canLeft, canRight, scrollByDir } = useHorizontalScroll({
		axis,
		dragToScroll,
		wheelMode,
		stepRatio,
		dragThresholdPx,
		ignoreDragFrom,

		arrowMode,
		snapSelector,
		snapAlign,
		arrowOverlapRatio,
	})

	const showLeft = showArrows && axis === 'x' && canLeft
	const showRight = showArrows && axis === 'x' && canRight

	return (
		<div className={`${s.wrap} ${className}`.trim()}>
			{showLeft && (
				<button
					type="button"
					onClick={() => scrollByDir('left')}
					className={`${s.navBtn} ${s.left}`}
					aria-label="Scroll left"
				>
					<span className={s.navBtn__icon}>
						<ArrowIcon />
					</span>
				</button>
			)}

			<div
				ref={ref}
				className={[
					s.inner,
					hideScrollbar ? s.hideScrollbar : '',
					axis === 'x' ? s.axisX : s.axisY,
					innerClassName,
				]
					.filter(Boolean)
					.join(' ')}
				{...bind}
			>
				{children}
			</div>

			{showRight && (
				<button
					type="button"
					onClick={() => scrollByDir('right')}
					className={`${s.navBtn} ${s.right}`}
					aria-label="Scroll right"
				>
					<span className={s.navBtn__icon}>
						<ArrowIcon />
					</span>
				</button>
			)}
		</div>
	)
}
